import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';
import styled from 'styled-components';
import moment from 'moment';
import Loader from '../../components/Loader';
import Api from '../../services/api';
import { getProp } from '../../utilities';

const DEFAULT_LANGUAGE = 'sk';

const LoaderWrapper = styled.div`
  margin: 2rem;
`;

export const locale = {
  lang: DEFAULT_LANGUAGE,
  translations: {
    [DEFAULT_LANGUAGE]: {},
  },
};

class LocaleProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFetching: true,
    };
  }

  componentDidMount() {
    this.loadLocale();
  }

  async loadLocale() {
    // detekcia jazyka
    const params = Api.paramsToObject(window.location.search);
    const cookieLang = Cookies.get('lang');

    let lang = DEFAULT_LANGUAGE;
    if (this.props.lang) {
      lang = this.props.lang;
    } else if (getProp(params, ['lang'], null)) {
      lang = getProp(params, ['lang'], null);
    } else if (cookieLang) {
      lang = cookieLang;
    }
    this.setState({ isFetching: true });

    locale.lang = lang; // nastavime globalnu premennu

    Api.lang = lang;

    moment.locale(
      (l => {
        switch (l) {
          case 'sk':
            return 'sk';
          case 'en':
            return 'en-gb';
          case 'ua':
            return 'uk';
          default:
            return 'sk';
        }
      })(lang),
    );

    if (lang === DEFAULT_LANGUAGE) {
      // ak je zvoleny slovensky jazyk, natahovanie prekladov nesmie zdrzat render apky
      // docitat ich ale mozeme, pretoze sa mozu lisit od defaultnych
      this.setState({ isFetching: false });
      locale.translations[lang] = await Api.getLocale(lang); // nastavime globalnu premennu
    } else {
      locale.translations[lang] = await Api.getLocale(lang); // nastavime globalnu premennu
      this.setState({ isFetching: false });
    }
  }

  render() {
    if (this.state.isFetching) {
      return (
        <LoaderWrapper>
          <Loader size="xl" />
        </LoaderWrapper>
      );
    }
    return this.props.children;
  }
}

LocaleProvider.propTypes = {
  lang: PropTypes.string,
  children: PropTypes.node.isRequired,
};

LocaleProvider.defaultProps = {
  lang: null,
};

export default LocaleProvider;



// WEBPACK FOOTER //
// ./src/containers/LocaleProvider/index.js